import { Navigate, Outlet, useLocation } from 'react-router-dom';
export default function ProtectedRoute() { const location = useLocation(); return localStorage.getItem('gd_carburanti_token') ? <Outlet /> : <Navigate to="/admin/login" replace state={{ from: location }} />; }
